import * as React from "react";
import "./footer.scss";

const Footer = () => {
  const currentYear = new Date().getFullYear()
  return (
    <footer className="footer d-flex align-items-center">
      <div className="container">
        <div className="row">
          <div className="col">
            &copy; 2006 - {currentYear} BRIAN LASKY. All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
